import React, {useState, useEffect} from 'react';

import { IHttpRequest } from  '@/interfaces/IHttp';
import { container, TYPES } from "@/inversifyconfig/container.config";
import { MoreDetailsResponse } from  '@/interfaces/LockerManagement';
import { IconLibrary, ThriveIcon } from 'thrive-components';


const MoreDetails = ({id, type}:{id:number, type: 'batch' | 'archive'}) =>  {
    const httpCall = container.get<IHttpRequest>(TYPES.IHttpRequest);
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [lockerFile, setLockerFile] = useState<MoreDetailsResponse>()

    useEffect(()=>{
        setLockerFile(undefined);
        setIsLoading(true);
        const url = type === 'batch'
            ? `locker/batches/${id}/details`
            : `locker/batches/${id}/archived/details`
        httpCall.get(url)
            .then(({data}:{data: MoreDetailsResponse})=> setLockerFile(data))
            .catch((err)=>{
               console.log("Batch Management Error: ", err.data)
            })
            .finally(() => setIsLoading(false));
    },[])
    

    const Detail: React.FunctionComponent<{title: string, iconName: IconLibrary, value: string, colour: string}> = ({title, iconName, value, colour}) => (
        <div className={`more-details-container`}>
            <div className="more-details-title-wrapper">
                <ThriveIcon 
                    iconName={iconName} 
                    sizeInPx='12'
                    color={colour}
                />

                <h4 className="more-details-heading">{title}</h4>
            </div>
            <p className="more-details-value">{value}</p>
        </div>
    )

    return (
        
        <div className="more-details-modal-wrapper">
            { isLoading || ! lockerFile
            ? isLoading ? <h3> Fetching Locker Details</h3>  : <h3>Could not find locker file</h3>
            : <>
                <Detail
                    title="Date Created"
                    iconName={IconLibrary.CALENDAR}
                    colour="var(--thrivePink)"
                    value={new Intl.DateTimeFormat('en-GB').format(new Date(lockerFile.dateCreated))}    
                />

                <Detail
                    title="Most recent batch update"
                    iconName={IconLibrary.REPEAT}
                    colour="var(--thriveGreyDark)"
                    value={new Intl.DateTimeFormat('en-GB').format(new Date(lockerFile.mostRecentBatchUpdate))} 
                />

                <Detail 
                    title="Total Number of Files"
                    iconName={IconLibrary.LIST}
                    colour="var(--thriveCharcoal)"
                    value={Intl.NumberFormat().format(+lockerFile.fileCount)}
                />

                <Detail
                    title="Total Number of Users"
                    iconName={IconLibrary.USERS}
                    colour="var(--thriveCMSTextEmphasisColor)"
                    value={Intl.NumberFormat().format(+lockerFile.userCount)}
                />

                <Detail
                    title="Unique Opens"
                    iconName={IconLibrary.FILE_DOWNLOAD}
                    colour="var(--thriveGold)"
                    value={Intl.NumberFormat().format(+lockerFile.uniqueOpens)}
                />   
            </>
            }
            
        </div>
)}

export default MoreDetails